import React from "react";
import { useNavigate } from "react-router-dom";
import "../../style/ReuploadScan.css";
import "../../style/slotbooking.css";
import {
  canUploadScanNow,
  formatSlotDate,
  formatSlotTime,
} from "../../utils/slotBooking";

interface SlotScanPendingProps {
  order: any;
  onUploadClick?: (caseID: number) => void;
  onCancelClick?: () => void;
  onClose?: () => void;
}

const SlotScanPending: React.FC<SlotScanPendingProps> = ({
  order,
  onUploadClick,
  onCancelClick,
  onClose,
}) => {
  const navigate = useNavigate();
  const uploadAllowed = canUploadScanNow(order?.slotDate);

  return (
    <div className="order-wrapper mt-4">
      <div className="order-card">
        <div className="order-header">
          <div>
            <strong className="number-fontweight">{order?.orderID}</strong>
            &nbsp; {order?.patientName}
          </div>
          <div className="header-actions">
            <span
              className="close-btn"
              style={{ cursor: "pointer" }}
              onClick={onClose}
            >
              ✕
            </span>
          </div>
        </div>

        <div className="eta order-header py-2">
          <div className="ETA_main"></div>
          <button className="reupload-badge">
            <i className="bi bi-calendar-check-fill me-1 text-white"></i>
            {order?.dentistTag}
          </button>
        </div>

        <div className="slot-info-box">
          <div className="slot-info-item">
            <i className="bi bi-calendar-event"></i>
            <div>
              <span className="slot-info-label">Scheduled Date</span>
              <strong>{formatSlotDate(order?.slotDate) || "-"}</strong>
            </div>
          </div>
          <div className="slot-info-item">
            <i className="bi bi-clock"></i>
            <div>
              <span className="slot-info-label">Scheduled Time</span>
              <strong>{formatSlotTime(order?.slotTime) || "-"}</strong>
            </div>
          </div>
        </div>

        <div className="order-footer pb-2 pt-3">
          <button
            className="btn btn-contact-section gray"
            onClick={() =>
              navigate("/dentist/ContactSupport", {
                state: {
                  caseIds: [order?.caseID],
                  orderId: order?.orderID,
                },
              })
            }
          >
            Contact Support
          </button>
          <button className="btn btn-contact-section red" onClick={onCancelClick}>
            Cancel Order
          </button>
        </div>
      </div>

      <div className="reupload-box">
        {!uploadAllowed && (
          <p className="slot-note-text">
            <i className="bi bi-info-circle"></i>
            <span>
              Scan upload will be available on{" "}
              <strong>{formatSlotDate(order?.slotDate)}</strong>.
            </span>
          </p>
        )}

        <button
          className="btn blue full"
          disabled={!uploadAllowed}
          onClick={() => onUploadClick?.(order?.caseID)}
        >
          Upload Scan
        </button>
      </div>
    </div>
  );
};

export default SlotScanPending;
